// extracted by mini-css-extract-plugin
export default {"msg-area":"ChatboxMsgArea_msg-area__deWS-"};